import { useContext } from "react";
import { MaintenanceDashboardContext } from "./Maintenance.provider";

export function useMaintenanceDashboardContext() {
  const context = useContext(MaintenanceDashboardContext);

  if (!context) {
    throw new Error("useMaintenanceDashboardContext deve ser utilizado apenas dentro de MaintenanceDashboardProvider")
  }

  return context
}